import React from 'react'
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const Button = ({className, to, filled = false, children, ...props}) => {

    return ( 
        <Link to={to}>
            <button  className={classNames("btn", {"filled" : filled}, className)} {...props}>
                {children} <span>→</span>
            </button>
        </Link>
    );
}
 
export default Button;